module.exports = __webpack_public_path__ + "img/ep-fleur-2.0db56b03.jpg";